import { CopyableText } from "./CopyableText.jsx";
import { formatMoneyForCopy } from "./money-copy.js";

export function CopyableMoney({
  as = "button",
  children,
  className = "",
  fallback = null,
  value,
}) {
  const copyValue = formatMoneyForCopy(value);
  if (!copyValue) return children ?? fallback;

  return (
    <CopyableText
      as={as}
      className={`suite-copyable-money ${className}`.trim()}
      copiedMessage="Importe copiado"
      errorMessage="No pudimos copiar el importe"
      label="importe"
      value={copyValue}
    >
      {children ?? copyValue}
    </CopyableText>
  );
}
